/*
OnlineOpinion v5.9.3
Released: 09/21/2015. Compiled 09/30/2015 12:09:31 PM -0500
Branch: 5.9.3 efe6bf2541deb563c2a9884b2a3034c881047acf
Components: Full
UMD: disabled
The following code is Copyright 1998-2015 Opinionlab, Inc. All rights reserved. Unauthorized use is prohibited. This product and other products of OpinionLab, Inc. are protected by U.S. Patent No. 6606581, 6421724, 6785717 B1 and other patents pending. http://www.opinionlab.com
*/

/* global window, OOo */

(function (w, d, o) {
    'use strict';

    // launches the opinion lab popup for a specialized productName survey
    w.launchOpinionLabSurvey = function (productName, event) {
        /* PayPal custom variables */
        var opVars = getOpinionLabVars();

        /* Feedback object configuration */
        o.oo_survey = new o.Ocode({
            referrerRewrite: w.location.protocol + '//surveys.paypal.com/' + opVars.countryCode + '/' + opVars.languageCode + '/' + productName,
            legacyVariables: {
                vars: opVars.tealeafId,
                override: true
            },
            customVariables: opVars
        });

        /* Display comment card */
        o.oo_survey.show(event, 'exit');
    };

    function getOpinionLabVars(){
        var opVars = {
                guid: userGuid,
                experimentId: pxpExpId,
                treatmentId: pxpTrmntId,
                tealeafId: userGuid,
                encryptedCustID: buyerId,
                fptiPageGroup: 'main:creditapplyweb:' + viewName + ':::::',
                fptiPagename: 'main:creditapplyweb:' + viewName + ':' + appStatus + '::::',
                countryCode: (country || '').toLowerCase(),
                languageCode: (language || '').toLowerCase()
            };
        return opVars;
    }

    // launches the opinion lab popup for the standard PayPal feedback form
    w.launchOpinionLabStandardFeedback = function (event) {
        /* PayPal custom variables */
        var opVars = getOpinionLabVars();

        /* Feedback object configuration */
        o.oo_feedback = new o.Ocode({
            referrerRewrite: w.location.protocol + '//www.paypal.com/' + opVars.countryCode + '/' + opVars.languageCode + '/' + opVars.fptiPagename,
            legacyVariables: {
                vars: opVars.tealeafId,
                override: true
            },
            customVariables: opVars
        });

        /* Display comment card */
        o.oo_feedback.show(event);
    };

})(window, document, OOo);
